import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { fetchMatchParticipantInsights } from 'tio-data/requests/match-participant';
import type { Store as StoreService } from '@warp-drive/core';
import type SessionContextService from 'tio-employee/services/session-context';
import type RouterService from '@ember/routing/router-service';
import type { MatchParticipantInsights } from 'tio-common/types/secure-your-future';
import type { MatchParticipantExtension as MatchParticipantModel } from 'tio-data/data/resources/match-participant.ext';
import type { MatchPlanExtension as MatchPlanModel } from 'tio-data/data/resources/match-plan.ext';

export type SyfInsightsFourOhOneKRouteModel = {
  matchParticipant: MatchParticipantModel;
  matchPlan: MatchPlanModel;
  insights?: MatchParticipantInsights;
};

export default class AuthenticatedSyfInsightsFourOhOneKRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;
  @service declare router: RouterService;

  beforeModel() {
    if (!this.sessionContext.currentEmployee.matchParticipant?.isEnrolled) {
      this.router.transitionTo('authenticated.syf.dashboard');
    }
  }

  async model(): Promise<SyfInsightsFourOhOneKRouteModel> {
    const participant = this.sessionContext.currentEmployee.matchParticipant;

    await fetchMatchParticipantInsights(this.store, participant);

    return {
      matchParticipant: participant,
      matchPlan: participant.matchPlan,
      insights: participant.insights,
    };
  }
}
